import React from "react";
import styled from "styled-components";
import { Profile } from "../../assets/svg";
import Loading from "../utils/loading";
import UpdateUserData from "./updateUserData";
import { editAccess } from "../utils/utils";
import UpdatePassword from "./UpdatePassword";
import UpdateUnitValue from "./UpdateUnitValue";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 65%;
  @media (max-width: 860px) {
    width: 87%;
  }
`;

const ProfileCard = styled.div`
  width: 100%;
  max-width: 460px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  animation: slideUp 0.5s ease-out;

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const ProfileHeader = styled.div`
  background: linear-gradient(135deg, #107066 0%, #0b5a52 100%);
  padding: 0.7rem 0.7rem 0.7rem;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
    animation: pulse 4s ease-in-out infinite;
  }

  @keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
  }
`;

const AvatarWrapper = styled.div`
  width: 120px;
  height: 120px;
  margin: 0 auto 1.5rem;
  background: white;
  border-radius: 50%;
  padding: 1rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1;

  svg {
    width: 100%;
    height: 100%;
  }
`;

const Name = styled.h1`
  color: white;
  margin: 0 0 0.5rem;
  font-size: 1.2rem;
  font-weight: 700;
  text-align: center;
  position: relative;
  z-index: 1;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const Email = styled.p`
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  font-size: 1rem;
  text-align: center;
  position: relative;
  z-index: 1;
  font-weight: 300;

  @media (max-width: 768px) {
    font-size: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const ContentSection = styled.div`
  padding: 0.5rem;
`;

const SectionDivider = styled.div`
  height: 1px;
  background: linear-gradient(90deg, transparent, #e0e0e0, transparent);
  margin: 1rem 0;
`;

const InfoNote = styled.div`
  max-width: 480px;
  width: 100%;
  margin-top: 1.5rem;
  padding: 0.75rem 1.2rem;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  
  p {
    color: white;
    font-size: 0.875rem;
    margin: 0;
    text-align: center;
    line-height: 1.5;
  }

  &::before {
    content: "ℹ️";
    margin-right: 0.5rem;
  }
`;

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
`;

export default function UserData({
  loading,
  userData,
}) {
  return (
    <Container>
      {loading ? (
        <LoadingWrapper>
          <Loading />
        </LoadingWrapper>
      ) : (
        <>
          <ProfileCard>
            <ProfileHeader>
              {/* <AvatarWrapper>
                <Profile />
              </AvatarWrapper> */}
              <Name>Hello, {userData.name}</Name>
              <Email>{userData.email}</Email>
            </ProfileHeader>

            <ContentSection>
              
                <>
                  <UpdateUserData
                    contact={userData.contact}
                    address={userData.address}
                  />
                  <SectionDivider />
                </>
              {/* <SectionDivider /> */}
              
              {/* <UpdateUnitValue loading={loading} userData={userData} /> */}
            </ContentSection>
          </ProfileCard>

          <UpdatePassword loading={loading} userData={userData} />

          {/* <InfoNote>
            <p>Please keep your contact details updated for seamless communication.</p>
          </InfoNote> */}
        </>
      )}
    </Container>
  );
}